import moment from 'moment';

// Utils.
import { getLanguage } from 'utils';

// Constants.
import * as DashboardDatePickerConstants from 'constants/DashboardDatePickerConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

moment.locale(getLanguage());

const initialState = {
  isFetching: false,
  isFetched: false,
  startDate: moment().subtract(30, 'days'),
  endDate: moment(),
  datePickerStatus: '',
  errorMessage: '',
};

export default function datasources(state = initialState, action = {}) {
  switch (action.type) {
    case DashboardDatePickerConstants.DASHBOARD_DATE_PICKER_CHANGE:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
        startDate: action.startDate,
        endDate: action.endDate,
        datePickerStatus: action.datePickerStatus,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        startDate: moment().subtract(6, 'days'),
        endDate: moment(),
        datePickerStatus: 'isWeek',
        errorMessage: '',
      };
    default:
      return state;
  }
}
